import { IconOptions } from 'primereact/utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const BargeSelected = (options: IconOptions) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...options.iconProps}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.97123 2.69355V4.3866H4.14131H3.31139V6.10456V7.82252H5.82556H8.33974V6.97599V6.12946H9.16967H9.99959V5.25803V4.3866H8.33974H6.6799V2.69355V1.00049H5.82556H4.97123V2.69355ZM12.4649 8.66904L11.6361 9.51557H6.64382H1.65154V11.6879V13.8603L1.78892 13.8322C2.23971 13.7403 3.07349 13.6888 3.70194 13.7141C4.91265 13.763 5.83313 13.9649 7.13523 14.4674C8.11132 14.844 8.81968 14.9975 9.73108 15.03C10.8821 15.0708 11.7053 14.9207 12.9134 14.4495C14.2794 13.9167 15.16 13.7408 16.5657 13.7201L17.5421 13.7058L17.7027 13.0677C18.0726 11.5974 18.3452 9.5211 18.3471 8.15864L18.3476 7.82252H15.8207H13.2938L12.4649 8.66904ZM16.2724 9.66471C16.7468 9.96374 16.7491 10.759 16.2763 11.057C15.7365 11.3974 15.0901 11.0761 15.0385 10.4419C14.9814 9.73945 15.6865 9.29538 16.2724 9.66471ZM2.18777 15.0183C1.64285 15.0942 0.897677 15.28 0.382246 15.4685C0.180868 15.5421 0.00902535 15.6088 0.000384386 15.6167C-0.00825658 15.6246 0.129852 15.9869 0.307309 16.422L0.629954 17.2129L1.10413 17.0523C1.94934 16.766 2.30855 16.7111 3.3358 16.7111C4.58146 16.7111 4.63458 16.7228 6.63108 17.4404C7.77979 17.8532 8.65946 17.9995 9.99959 18.0005C11.5043 18.0016 12.3153 17.8435 13.9265 17.2351C15.1426 16.7758 15.7931 16.66 16.9244 16.7011C17.7518 16.7312 18.1599 16.804 18.8964 17.053L19.372 17.2138L19.5146 16.8628C19.9371 15.8234 20.0125 15.6291 19.9984 15.6157C19.95 15.5696 19.0426 15.2699 18.696 15.1856C16.9653 14.7645 15.216 14.8929 13.4517 15.5706C11.9999 16.1283 11.3457 16.2597 10.024 16.2593C8.66024 16.2589 8.02374 16.1344 6.60432 15.5906C5.80159 15.2831 5.16255 15.1132 4.45072 15.018C3.78439 14.9289 2.82857 14.929 2.18777 15.0183Z'
        fill='#27292D'
        fillOpacity='0.8'
      />
    </svg>
  );
};

export default BargeSelected;
